import { BoxProps } from '@material-ui/core'
import { Box, Grid, Grow, useTheme } from '@mui/material'
import { isFunction } from 'lodash'
import React, { FC } from 'react'
import { PAGE_SIZE } from '../../../config'
import { BETMEN_LIST_ITEM_CARD_BOX_SHADOW } from '../../../theme'
import { BetmenListItemCardCellProps } from './BetmenListItemCardCell'

export interface BetmenListItemCardProps extends BoxProps {
  click?: () => void
  animate?: boolean
  'data-cy'?: string
  itemindex?: number
}

export const BetmenListItemCard: FC<
  React.PropsWithChildren<BetmenListItemCardProps>
> = ({ click, animate = true, 'data-cy': dataCy, children, sx, ...props }) => {
  const theme = useTheme()
  const isClickable = isFunction(click)
  const indexOfComponent = (props as typeof props & { itemindex: number })
    .itemindex

  return (
    <Grow
      in={animate}
      timeout={indexOfComponent < PAGE_SIZE - 3 ? indexOfComponent * 200 : 500}
    >
      <Box
        mb={2}
        display="flex"
        alignItems="center"
        p={2}
        overflow="hidden"
        borderRadius={theme.spacing(2)}
        boxShadow={BETMEN_LIST_ITEM_CARD_BOX_SHADOW}
        sx={{
          background: theme.palette.common.white,
          cursor: isClickable ? 'pointer' : 'auto',
          transition: isClickable ? 'all .2s ease-in-out' : 'none',
          ':hover': {
            transform: isClickable ? 'scale(1.005)' : 'none',
          },
          ...sx,
        }}
        onClick={click}
        {...props}
        data-cy={dataCy || 'BetmenListItemCard'}
      >
        <Grid container alignItems="center">
          {React.Children.map(children, (child, i) => {
            if (React.isValidElement<BetmenListItemCardCellProps>(child)) {
              return React.cloneElement(child, {
                ...(typeof child.props === 'object' ? child.props : {}),
                cellindex: i,
              })
            }

            return child
          })}
        </Grid>
      </Box>
    </Grow>
  )
}
